﻿import * as React from "react";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

const responsive = {
    superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: { max: 4000, min: 3000 },
        items: 5
    },
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 5
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 3
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1
    }
};

class HomeLogoCarousel extends React.Component {
    render() {
        return (
            <Carousel responsive={responsive}>
                <div className="brand-logo">
                    <img src="../img/Premier-WestinKierland-Logo.png" />
                </div>
                <div className="brand-logo">
                    <img src="../img/Premier-JWMarriott-Logo.png" />
                </div>
                <div className="brand-logo">
                    <img src="../img/Premier-Phoenician-Logo.png" />
                </div>
                <div className="brand-logo">
                    <img src="../img/Premier-Salcito-Logo.png" />
                </div>
                <div className="brand-logo">
                    <img src="../img/Premier-GMHunt-Logo.png" />
                </div>
                <div className="brand-logo">
                    <img src="../img/Premier-FRConstruction-Logo.png" />
                </div>
            </Carousel>
        );
    }
}

export default HomeLogoCarousel;